<template>
  <v-card
    class="d-flex flex-column py-12"
    tile
    elevation="0"
    :min-height="settings.bg && settings.bg.height ? settings.bg.height : '500px'"
    :color="MIXIN_getBgInfo(settings, 'color')"
    :img="MIXIN_getBgInfo(settings, 'image')"
  >
    <section class="d-flex flex-column flex align-center justify-center">  
      <div>
        <title-component :id="id" :settings="{...settingsTitle, idLayout: settings.idLayout}" />
      </div>

      <div class="pt-6 d-flex flex-column" style="max-width: 1340px; width: 90%">
        <v-container style="max-width: 1340px">
          <v-row no-gutters justify="space-around" align="center">
            <v-col
              v-for="(item, i) in settings.items"
              :key="i"
              :cols="$vuetify.breakpoint.mdAndUp ? '4' : '12'"
              class="px-12 pt-12"
            >
              <section class="pa-4">
                <span 
                  class="spanContent pb-4" 
                  :style="`font-style: italic; font-size: 0.9rem; font-family: ${MIXIN_getStyle(settings, 'title', 'font')} !important;`"
                >
                  {{ item.text }}
                </span>
                <div class="d-flex flex-column align-end">
                  <span :style="`font-family: ${MIXIN_getStyle(settings, 'title', 'font')} !important; font-weight: 600`">
                    {{ item.name }}
                  </span>
                  <span :style="`font-family: ${MIXIN_getStyle(settings, 'title', 'font')} !important;`">
                    {{ item.company }}
                  </span>
                </div>
              </section>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </section>
  </v-card>
</template>

<script>
import TitleComponent from "../title/TitleComponent.vue";
import { GetLayoutSectionMixin } from "../../mixins/GetLayoutSection"

export default {
  mixins: [GetLayoutSectionMixin],  
  components: { TitleComponent },
  props: {
    id: {type: String},
    settings: {
      type: Object,
    },
  },

  data() {
    return {
      settingsTitle: null,
      hover: false,
    };
  },

  created() {
    this.settingsTitle = {
      title: this.settings.title,
      subtitle: this.settings.subtitle,
      "background-color": "transparent",
    };
  },
};
</script>

<style scoped>
h3,
b,
span {
  text-align: start;
}

.spanContent {
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: 0.25px;
}

b {
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: 0.25px;
}

span {
  display: block;
  font-size: 0.85rem;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0px;
}
</style>